import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import axios from "axios";
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

const AddDebit = () => {

    let history = useNavigate();

    const [data, setData] = useState({
        date: "",
        debit: ""
    });

    const [selectedClientId, setSelectedClientId] = useState(''); // To store clid
    const [clients, setClients] = useState([]);

    useEffect(() => {
        fetch('https://react-apis.dotlocalhost.com/allclient.php')
            .then(response => response.json())
            .then(data => setClients(data))
            .catch(error => console.error('Error fetching client names:', error));
    }, []);

    const handleClientChange = (event) => {
        setSelectedClientId(event.target.value); // Store the selected clid
    };

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const submitForm = (e) => {
        e.preventDefault();
        const sendData = {
            date: data.date,
            clientName: selectedClientId, // Send clid here
            debit: data.debit,            
        };

        console.log(sendData);

        axios.post('https://react-apis.dotlocalhost.com/addDebit.php', sendData).then((result) => {
            if (result.data.data.status === 'invalid') {
                alert('Invalid purchase');
            } else {
                history('/viewledger');
            }
        });
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />
                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Add Debit Amount</h3>
                        </div>
                    </div>
                    <form onSubmit={submitForm}>
                        <div className='row'>
                            <div className='col-3'>
                                <label htmlFor="" className="form-label">Date</label>
                                <input type="date" name="date" className='form-control' onChange={handleChange} value={data.date} />
                            </div>
                            <div className='col-3'>
                                <label htmlFor="clientDropdown">Client Name</label>
                                <select id="clientDropdown" name="clientName" value={selectedClientId} className='form-control' onChange={handleClientChange}>
                                    <option value="">--Select Client--</option>
                                    {clients.map((client, index) => (
                                        <option key={index} value={client.clid}>{client.clientName}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-3'>
                                <label htmlFor="" className="form-label">Amount</label>
                                <input type="text" name="debit" className='form-control' onChange={handleChange} value={data.debit} />
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-6 mt-3 mb-5'>
                                <div className="d-grid gap-3">
                                    <input type="submit" name="submit" value="Add New Purchase" className="btn btn-primary btn-block" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddDebit;
